// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"48":"b55c077e","126":"1b54275f","172":"1b0e71a1","384":"7329c911","413":"9c59a21e","493":"3e560909","513":"8e64a0db","660":"47d1d8e8","943":"4d852eb0"}[chunkId] + ".chunk.js";
};